<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="teal">group</v-icon>
            失信论文列表
            <v-spacer/>
            <v-btn flat round color="primary" dark
                   :disabled="!funcIds.includes('c_integrity_paper')"
                   @click.native.stop="
             () => {
                  addDbid = infoBasic? infoBasic.dbid: null;
                  add = true;
                }">
                <v-icon>add</v-icon>
                新增论文
            </v-btn>
        </v-card-title>

        <v-divider color="teal"/>

        <v-card-text class="pt-0">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-0 dense"
                    no-data-text="没有数据。"
            >
                <template slot="items" slot-scope="props">
                    <td>{{props.index + 1}}</td>
                    <td class="">{{props.item.title}}</td>
                    <td class="">{{props.item.pubDate}}</td>
                    <td class="">{{props.item.sourceName}}</td>
                    <td class="justify-center layout px-0">
                        <v-tooltip top>
                            <v-btn
                                    icon class="mx-0" slot="activator"
                                    :disabled="!funcIds.includes('u_integrity_paper')"
                                    @click="
                                     () => {
                                        editDbid = props.item.dbid;
                                        addDbid  = props.item.integId;
                                         add = true;
                                        }">
                                <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <span>编辑</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn icon class="mx-0" slot="activator"
                                   :disabled="!funcIds.includes('d_integrity_paper')"
                                   @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.title}`;
                        dele = true;
                     }">
                                <v-icon color="pink">delete_forever</v-icon>
                            </v-btn>
                            <span>删除</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <x-papaer-add
                v-model="add"
                :integId="addDbid"
                :dbid="editDbid"
                v-on:ok="onAddOk"
        />

        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="uri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />

    </v-card>
</template>
<script>
    import {mapGetters} from 'vuex'
    import XPapaerAdd from './paperAdd'

    import XDelete from '@/components/global/Delete'

    const baseURI = '/api/integrity/integrity';
    export default {
        components: {XPapaerAdd, XDelete},
        props: {
            infoBasic: Object
        },

        data: () => ({
            uri: baseURI+'/paper',
            headers: [
                {
                    text: '#',
                    sortable: false,
                    value: 'dbid',
                    width: '20'
                },
                {text: '论文名称', value: 'title', sortable: false, width: 200},
                {text: '发表时间', value: 'pubDate', sortable: false, width: 20},
                {text: '期刊名称', value: 'sourceName', sortable: false, width: 120},
                {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 120}
            ],
            form: {
                partId: '',
            },
            items: [],

            add: false,
            addDbid: null,
            editDbid: null,

            loading: false,

            dele: false,
            deleDbid: null,
            deleMsg: null,

        }),

        beforeMount() {
        },

        watch: {
            infoBasic(p) {
                const dbid = p.dbid;
                this.axios
                    .get(`${baseURI}/paper/${dbid}`)
                    .then(rsp => {this.items = rsp.data.items})
            }
        },

        computed: {
            ...mapGetters(['funcIds'])
        },
        methods: {
            getDefault() {
                return {
                    integId: this.infoBasic.dbid,
                    serialNum: this.items.length + 1,
                    property: !this.items.length ? '新增' : '追加',
                }
            },
            onAddOk(its) {
                window.console.log(its);
                if (its) {
                    this.items.unshift(its);
                }
            },
            onDeleOk(item) {
                if (item) {
                    const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
                    this.items.splice(deleIdx, 1);
                }
            },
        }
    }
</script>
